import { fetchApi } from "./api";
import { API_ENDPOINTS } from "@/config/api";

export interface SourceCoupon {
  id: number;
  source_id: string;
  product_id: number | null;
  code: string;
  label: string;
  description: string | null;
  /** Decimal serialized as string by FastAPI, e.g. "10.00" */
  discount_percent: string | null;
  start_date: string | null;
  end_date: string | null;
  created_at: string;
  updated_at: string;
}

export interface SourceCouponCreate {
  source_id: string;
  product_id?: number | null;
  code: string;
  label: string;
  description?: string | null;
  discount_percent?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}

export interface SourceCouponUpdate {
  code?: string;
  label?: string;
  description?: string | null;
  discount_percent?: string | null;
  start_date?: string | null;
  end_date?: string | null;
}

export interface ListCouponsParams {
  source_id?: string;
  product_id?: number;
}

export async function listCoupons(
  params?: ListCouponsParams,
): Promise<SourceCoupon[]> {
  const search = new URLSearchParams();
  if (params?.source_id) search.set("source_id", params.source_id);
  if (params?.product_id != null)
    search.set("product_id", String(params.product_id));
  const query = search.toString();
  const url = query
    ? `${API_ENDPOINTS.coupons}?${query}`
    : API_ENDPOINTS.coupons;
  return fetchApi<SourceCoupon[]>(url);
}

export async function createCoupon(
  data: SourceCouponCreate,
): Promise<SourceCoupon> {
  return fetchApi<SourceCoupon>(API_ENDPOINTS.coupons, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updateCoupon(
  id: number,
  patch: SourceCouponUpdate,
): Promise<SourceCoupon> {
  return fetchApi<SourceCoupon>(API_ENDPOINTS.couponById(id), {
    method: "PUT",
    body: JSON.stringify(patch),
  });
}

export async function deleteCoupon(id: number): Promise<void> {
  return fetchApi<void>(API_ENDPOINTS.couponById(id), {
    method: "DELETE",
  });
}
